const EditIconWhite = () => (
  <div>
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 2.66602H12C5.33332 2.66602 2.66666 5.33268 2.66666 11.9993V19.9993C2.66666 26.666 5.33332 29.3327 12 29.3327H20C26.6667 29.3327 29.3333 26.666 29.3333 19.9993V17.3327"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3867 4.027L10.88 14.5337C10.48 14.9337 10.08 15.7203 9.99999 16.2937L9.42666 20.307C9.21332 21.7603 10.24 22.7737 11.6933 22.5737L15.7067 22.0003C16.2667 21.9203 17.0533 21.5203 17.4667 21.1203L27.9733 10.6137C29.7867 8.80034 30.64 6.69367 27.9733 4.027C25.3067 1.36034 23.2 2.21367 21.3867 4.027Z"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.88 5.5332C20.7733 8.71987 23.2667 11.2132 26.4667 12.1199"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default EditIconWhite;
